import { Module } from '../Module';

const MAX_PORT = 65535;

// Allows port values 0 through 65535
Module.instance().directive('tbPortInputValidator',
  () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
        const isValidPort = (val: any) => (/^\d*$/.exec(val) && parseInt(val, 10) <= MAX_PORT);

        ctrl.$parsers.push((inputVal: any) => {
          ctrl.$setValidity('port', !inputVal || !!isValidPort(inputVal));
          return inputVal;
        });
      }
    };
  }
);
